(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('FaqManageService', FaqManageService);

    FaqManageService.$inject = ['$resource', 'DateUtils'];

    function FaqManageService ($resource, DateUtils) {
        var resourceUrl =  'api/faq-category/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.syncDateTime = DateUtils.convertDateTimeFromServer(data.syncDateTime);
                    }
                    return data;
                },
            },
            'update': { method:'PUT' }
        });
    }
})();
